import React, { useRef } from "react";
import { ContentCard } from "@/components/ContentCard";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function ContentRow({ title, items, ranked }) {
  const scroller = useRef(null);
  if (!items || items.length === 0) return null;

  const scroll = (dir) => {
    const el = scroller.current;
    if (el) el.scrollBy({ left: dir * el.clientWidth * 0.85, behavior: "smooth" });
  };

  return (
    <section className="relative px-4 md:px-12 my-8 group/row">
      <h2 className="font-display text-xl sm:text-2xl font-bold text-white mb-4 flex items-center gap-2">
        {title}
      </h2>
      <div className="relative">
        <button
          onClick={() => scroll(-1)}
          className="hidden md:flex absolute -left-2 top-0 bottom-0 z-40 w-10 items-center justify-center bg-gradient-to-r from-[#0B0E14] to-transparent opacity-0 group-hover/row:opacity-100 transition-opacity"
        >
          <ChevronLeft size={30} className="text-white hover:scale-125 transition-transform" />
        </button>
        <div ref={scroller} className={`flex gap-3 overflow-x-auto no-scrollbar pb-6 ${ranked ? "items-end" : ""} pt-2`}>
          {items.map((item, i) => (
            <ContentCard key={item.id} item={item} rank={ranked ? i + 1 : undefined} />
          ))}
        </div>
        <button
          onClick={() => scroll(1)}
          className="hidden md:flex absolute -right-2 top-0 bottom-0 z-40 w-10 items-center justify-center bg-gradient-to-l from-[#0B0E14] to-transparent opacity-0 group-hover/row:opacity-100 transition-opacity"
        >
          <ChevronRight size={30} className="text-white hover:scale-125 transition-transform" />
        </button>
      </div>
    </section>
  );
}
